import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FrameProofLink } from 'site-modules/shared/components/ai-link/frame-proof-link';
import { AiLinkContent } from 'site-modules/shared/components/ai-link/ai-link-content';

import './ai-link.scss';

export const AiLink = memo(({ classes = 'w-100', linkClasses = '' }) => {
  return (
    <div className={classnames('ai-link-wrapper d-flex justify-content-end justify-content-lg-center', classes)}>
      <FrameProofLink
        className={classnames(
          'ai-link keep-style-in-critical-even-if-not-in-dom rounded-8 px-0_75 py-0_5 text-decoration-none text-nowrap d-flex justify-content-center align-items-center',
          linkClasses
        )}
      >
        <AiLinkContent />
      </FrameProofLink>
    </div>
  );
});

AiLink.displayName = 'AiLink';
AiLink.propTypes = {
  classes: PropTypes.string,
  linkClasses: PropTypes.string,
};
